import React, { useEffect, useRef } from "react";
import { useChatStore } from "../../services/ChatStore";
import { Box, Typography, Container, Paper } from "@mui/material";
import ChatInput from "./ChatInput";
import ChatMessage from "./ChatMessage";

export default function ChatWindow() {
  const { chats, activeChatId } = useChatStore();

  const scrollableBoxRef = useRef(null); // Ref на сам прокручиваемый контейнер

  // УДАЛЯЕМ messagesEndRef, он больше не нужен
  // const messagesEndRef = useRef(null);

  const activeChat = activeChatId ? chats[activeChatId] : null;
  const messages = activeChat ? activeChat.messages : [];

  // --- ИСПРАВЛЕННАЯ ЛОГИКА АВТО-ПРОКРУТКИ ---
  useEffect(() => {
    const scrollableBox = scrollableBoxRef.current;
    if (!scrollableBox) return; // Если реф еще не применился

    // ЕСЛИ: Чат очищен (или это первый заход)
    if (messages.length === 0) {
      // Принудительно прокручиваем ВВЕРХ
      scrollableBox.scrollTop = 0;
    }
    // ИНАЧЕ: Сообщения есть
    else {
      // Принудительно прокручиваем ВНИЗ
      // Устанавливаем scrollTop равным полной высоте контейнера
      scrollableBox.scrollTop = scrollableBox.scrollHeight;
    }
  }, [
    messages.length, // Срабатывает при добавлении/удалении сообщения
    messages[messages.length - 1]?.text, // Срабатывает во время стриминга
    activeChatId, // Срабатывает при смене чата
  ]);
  // --- КОНЕЦ ИСПРАВЛЕНИЯ ---

  return (
    <Box
      sx={{
        flexGrow: 1,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "grey.50",
      }}>
      {/* --- Ref теперь на этом Box --- */}
      <Box
        ref={scrollableBoxRef} // <--- ПРИМЕНЯЕМ REF
        sx={{
          flexGrow: 1,
          overflowY: "auto",
          p: 3,
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}>
        {/* --- Заголовок "AI-Zere" --- */}
        <Typography
          variant="h4"
          sx={{
            fontWeight: "bold",
            color: "text.primary",
            mb: 2,
            textAlign: "center",
          }}>
          AI-Zere
        </Typography>

        {messages.length > 0 ? (
          messages.map((msg, index) => (
            <ChatMessage key={index} message={msg} />
          ))
        ) : (
          // --- Заглушка, если нет сообщений ---
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexGrow: 1,
            }}>
            <Typography variant="h6" color="text.secondary">
              Как я могу вам помочь сегодня?
            </Typography>
          </Box>
        )}

        {/* УДАЛЕН messagesEndRef (div) */}
      </Box>

      {/* --- Поле ввода --- */}
      <Box sx={{ p: 2, backgroundColor: "background.paper" }}>
        <Container maxWidth="md">
          <ChatInput />
        </Container>
      </Box>
    </Box>
  );
}
